import { initHomePage } from "./pages/home";
import { openModal, closeModal } from "./modal";
import { submitContactForm } from "./pages/contact-form";
import { openMobileMenu, closeMobileMenu } from "./mobile-menu";


(window as any).SLC = {

    // Pages
    pages: {
        home: {
            init: initHomePage
        }
    },

    // Modal
    modal: {
        open: openModal,
        close: closeModal
    },

    // Forms
    form: {
        contact: {
            submit: submitContactForm
        }
    },

    // Mobile Menu
    menu: {
        open: openMobileMenu,
        close: closeMobileMenu
    }

};


// Notify listeners that SLC is setup and ready to use
declare const slcNotifyLoaded: Function;
slcNotifyLoaded();
